import React, { useState, useMemo } from "react";
import { Row, Col } from "react-bootstrap";
import { Card, CardBody } from "../../../_metronic/_partials/controls";
import { useSelector } from "react-redux";
import Select from "react-select";
import SVG from "react-inlinesvg";
import { formatCurrency } from "../../../helpers/numberFormat";
import { toAbsoluteUrl } from "../../../_metronic/_helpers";
import { useIsCrypto } from "../../../helpers";
import { CurrencyLogo } from "../../../helpers/CryptoCurrencySymbol";

const TotalTransaction = (props) => {
  const { generalSettings } = useSelector((state) => state.settings);
  const [manualCurrency, setManualCurrency] = useState(null);

  const currencyOptions = useMemo(() => {
    if (!props.totalAmountWiseDetail) return [];
    const unique = [
      ...new Map(
        props.totalAmountWiseDetail.map((item) => [item.code, item])
      ).values(),
    ];
    return unique.map((item) => ({
      value: item.code,
      label: !import.meta.env.VITE_ALLOWED_CRYPTO_CURRENCY?.split(",").includes(
        item.code
      ) ? (
        ` ${item.symbol} ${item.code}`
      ) : (
        <span className="d-flex align-items-center gap-1">
          <CurrencyLogo symbol={item?.symbol} variant="dark" height={15} />
          {item.code}
        </span>
      ),
    }));
  }, [props.totalAmountWiseDetail]);

  const defaultCurrency = useMemo(() => {
    if (!generalSettings?.currencyId || !currencyOptions.length) return null;

    return (
      currencyOptions.find(
        (opt) => opt.value === generalSettings.currencyId.code
      ) || null
    );
  }, [generalSettings, currencyOptions]);

  const selectedCurrency =
    manualCurrency || defaultCurrency || currencyOptions[0] || null;

  const filteredData = useMemo(() => {
    if (!props.totalAmountWiseDetail || !selectedCurrency) return [];
    return props.totalAmountWiseDetail.filter(
      (item) => item.code === selectedCurrency.value
    );
  }, [props.totalAmountWiseDetail, selectedCurrency]);

  const isCryptoProject = useIsCrypto(selectedCurrency?.value);

  const totalTransViewdata =
    filteredData.length > 0
      ? filteredData.map((transaction, key) => (
          <Col key={key}>
            <div className="d-flex flex-wrap flex-md-nowrap align-items-center gap-5">
              <div className="w-100 rounded-4 d-flex align-items-center justify-content-between info-bg-clr p-4 py-2 text-black">
                <div className="w-100">
                  <p className="mb-0">Total Amount</p>
                  <p className="mb-0 fw-bolder font-size-lg d-flex align-items-center gap-1">
                    {isCryptoProject ? (
                      <CurrencyLogo
                        symbol={transaction.symbol}
                        variant="dark"
                        height={18}
                      />
                    ) : null}
                    {formatCurrency(
                      transaction.totalAmount ?? 0,
                      generalSettings.currencySymbolSide,
                      transaction.symbol,
                      transaction.code,
                      generalSettings.decimalPoints
                    )}
                  </p>
                </div>
                <div>
                  <span>
                    <SVG
                      height={40}
                      width={40}
                      src={toAbsoluteUrl("media/svg/icons/General/amount.svg")}
                    />
                  </span>
                </div>
              </div>
              <div
                style={{ backgroundColor: "#e4f3ef" }}
                className="w-100 rounded-4 d-flex align-items-center justify-content-between py-2 p-4 text-black">
                <div className="w-100">
                  <p className="mb-0">Total Earned Amount</p>
                  <p className="mb-0 fw-bolder font-size-lg d-flex align-items-center gap-1">
                    {isCryptoProject ? (
                      <CurrencyLogo
                        symbol={transaction.symbol}
                        variant="dark"
                        height={18}
                      />
                    ) : null}
                    {formatCurrency(
                      transaction.totalearnedFee ?? 0,
                      generalSettings.currencySymbolSide,
                      transaction.symbol,
                      transaction.code,
                      generalSettings.decimalPoints
                    )}
                  </p>
                </div>
                <div>
                  <span>
                    <SVG
                      height={40}
                      width={40}
                      src={toAbsoluteUrl(
                        "media/svg/icons/General/earn-amount.svg"
                      )}
                    />
                  </span>
                </div>
              </div>
            </div>
          </Col>
        ))
      : null;

  return (
    <Card className=" p-0 shadow-none border-0 bg-transparent mt-4">
      <CardBody className="p-0 bg-transparent">
        <Row className="align-items-center">
          {totalTransViewdata}
          <Col className="mt-5 mt-md-0" md={"auto"}>
            <Select
              options={currencyOptions}
              value={selectedCurrency}
              className="filter-select-container"
              classNamePrefix="filter-select"
              onChange={setManualCurrency}
              isSearchable={false}
              placeholder="Select Currency..."
              styles={{
                control: (base, state) => ({
                  ...base,
                  background: "white !important",
                  height: 50,
                  verticalAlign: "center",
                  fontWeight: 700,
                  padding: 12,
                  width: 130,
                }),
              }}
            />
          </Col>
        </Row>
      </CardBody>
    </Card>
  );
};

export default TotalTransaction;
